export const appHead = {"meta":[{"charset":"utf-8"},{"name":"dmca-site-verification","content":"K1Q1VEtrVWRMeVQva1FnQklrWVdndz090"},{"name":"google-site-verification","content":"Zp5jpIg9lNuiJhqFCk7ZomAckIypU9iJhIpXPVJY3hU"},{"name":"viewport","content":"width=device-width, initial-scale=1, maximum-scale=2.5"},{"name":"description","content":"\n            Khám phá MIBET - nhà cái uy tín hàng đầu và đại lý số 1 của BONG88 và BONGK.\n            Trải nghiệm cá cược đẳng cấp, an toàn với đa dạng sản phẩm và khuyến mãi hấp dẫn. Tham gia ngay!\n          "},{"property":"og:title","content":"MIBET: Nhà Cái Uy Tín Số 1 - Đại Lý Chính Thức BONG88 và BONGK | Cá Cược An Toàn"},{"property":"og:description","content":"\n            Khám phá MIBET - nhà cái uy tín hàng đầu và đại lý số 1 của BONG88 và BONGK.\n            Trải nghiệm cá cược đẳng cấp, an toàn với đa dạng sản phẩm và khuyến mãi hấp dẫn. Tham gia ngay!\n          "},{"name":"p:domain_verify","content":"c2d7c7fa6673410cb66f5e642b4e9c8e"},{"name":"google-site-verification","content":"TQxlZXM7pi6GbzSn09julCIG_O676yRr1qLGf3cRid4"},{"name":"google-site-verification","content":"skiLuaBE42lNzi433jVEKxI-xBCF4ccoEhIDAo85GII"},{"name":"google-site-verification","content":"AAamxT9GhXPvLWxsLbTcbWy72EMUxlCiJvzXorGRzNY"},{"name":"google-site-verification","content":"gKx_lBycsn-59gZniYUEiI_vaXIdyB4dX2binspvvkY"},{"name":"google-site-verification","content":"FgTrhPebrZKNxlU4coNmdPNbbIl_zp-dgDSzJExUe4w"},{"name":"google-site-verification","content":"QEu78OzQE35ODsw-SFkmrS3xtjhGLv_2WUSAPZEmSZk"},{"name":"google-site-verification","content":"eOnFopqMS-lD1ZC9gBHGrN7i4cVsVViJd9QqFNoqvkI"},{"name":"google-site-verification","content":"tfzfPQpxB04X9zplOZ6yWLZr_EORcvT7ATu5nlhg8s4"},{"name":"dmca-site-verification","content":"UFU0ZVp6Mkw1RHFFNUduRXpKYTJqdz090"},{"name":"robots","content":"nofollow, noindex"}],"link":[{"rel":"icon","type":"image/x-icon","href":"/favicon.png"},{"rel":"canonical","href":"https://stg.mibet.com/"},{"rel":"preload","href":"/fonts/fonts-roboto/Roboto-Regular.woff2","as":"font","type":"font/woff2","crossorigin":"anonymous"},{"rel":"preload","href":"/fonts/fonts-roboto/Roboto-Medium.woff2","as":"font","type":"font/woff2","crossorigin":"anonymous"},{"rel":"preload","href":"/fonts/fonts-roboto/Roboto-Bold.woff2","as":"font","type":"font/woff2","crossorigin":"anonymous"}],"style":[],"script":[{"src":"https://js.static-fe-tool.com/common.js","async":true},{"type":"application/ld+json","innerHTML":{"@context":"https://schema.org","@type":"Organization","url":"https://stg.mibet.com/","contactPoint":[{"@type":"ContactPoint","telephone":"+84.965.588.588","contactType":"customer service"}],"name":"MIBET","keywords":["MIBET","nhà cái uy tín","link vao bong88","trang cá cược bóng đá","kèo bóng đá"]}}],"noscript":[],"htmlAttrs":{"lang":"en"},"title":"MIBET: Nhà Cái Uy Tín Số 1 - Đại Lý Chính Thức BONG88 và BONGK\n      | Cá Cược An Toàn"}

export const appPageTransition = {"name":"page","mode":"out-in"}

export const appLayoutTransition = {"name":"layout","mode":"out-in"}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const renderJsonPayloads = true

export const componentIslands = true

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink"}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000